export default {
  fields: {
    discount: {
      label: 'Desconto',
    },
    usage_threshold: {
      label: 'Valor mínimo de encomenda',
    },
    max_discount: {
      label: 'Valor máximo de desconto',
    },
  },
};
